import { z } from 'zod';

/**
 * Sign-in's address. `next` is where to go afterwards, app-relative only: a value that is not
 * (`//evil.example`, `https://…`) is dropped and sign-in opens as it is, never the failure screen
 * (pass 3, 2026-10-06; no open redirect either way).
 */
export const signInSearch = z.object({
  next: z
    .string()
    .regex(/^\/(?!\/)/)
    .optional()
    .catch(undefined),
  /** `done` straight after a new password was saved (`/reset-password`): the page says so. */
  reset: z.enum(['done']).optional().catch(undefined),
});
